export default (referrer, identifier) => {
  let args = `referrer: "${referrer}"`
  if (identifier) args += `, identifier: "${identifier}"`

  return `
    {
      promoBanner(${args}) {
        identifier
        headline
        text
        linkUrl
        linkText
        cookieLifetime

        images {
          url
          width
          height
          position
        }
      }
    }
  `
}
